'use client'

import { useState } from 'react'
import { usePathname } from 'next/navigation'
import Header from './Header'
import Footer from './Footer'
import { useVisitTracking } from '@/lib/commerce/hooks'
import { canShowCustomerChat, isAuthRoute } from '@/utils/util'
import CustomerChat from '../customer-chat/CustomerChat'
import RewardVariantModal from '../cart/RewardVariantModal'
import MobileBottomNav from '@/components/blocks/MobileBottomNav'

export default function Layout({ children, vendor, categories, brands, customer, subscription, campaigns }: { children: React.ReactNode, vendor: any, categories: any, brands?: any[], customer: any, subscription?: any, campaigns?: any }) {
  useVisitTracking(vendor)
  const pathname = usePathname()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const fontClass = 'font-roboto'

  if (isAuthRoute(pathname)) {
    return <div className={fontClass}>{children}</div>
  }

  return (
    <div className={`${fontClass} min-h-screen bg-cream text-foreground`}>
      <Header vendor={vendor} categories={categories} subscription={subscription} campaigns={campaigns} mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <main>
        {children}
      </main>
      <Footer vendor={vendor} subscription={subscription} brands={brands} />
      {canShowCustomerChat(vendor, subscription) && <CustomerChat vendor={vendor} />}
      <MobileBottomNav vendor={vendor} customer={customer} subscription={subscription} setMobileMenuOpen={setMobileMenuOpen} />
      <RewardVariantModal />
    </div>
  )
}
